import * as m from 'motion/react-m'
import { LayoutGroup } from 'motion/react'
import { MotionLayout } from '@/lib/motion/lazy-motion'

import Tooltip from '@/components/ui/Tooltip'
import { Icon } from '@/icons/Icon'

import { useChatContext } from '@/context/ChatContext'
import { cn } from '@/lib/utils'

export default function ContextToggle({ condensed }: { condensed?: boolean }) {
  const { context, handleContextSwitch } = useChatContext()

  const toolbar = [
    { label: 'Search', type: 'search', icon: 'magnifier-small' },
    { label: 'Chat', type: 'chat', icon: 'chat' },
  ]

  return (
    <LayoutGroup id="chat-toolbar">
      <ul className="flex items-center gap-0 rounded-full bg-gray-100 p-[3px] transition-colors dark:bg-white/10">
        {toolbar.map((item) => {
          const isActive = context === item.type

          return (
            <li
              onClick={() => handleContextSwitch(item.type as any)}
              key={item.label}
              className={cn('relative cursor-pointer px-[1.5px] first:pl-0 last:pr-0')}
            >
              <Tooltip
                text={item.label ?? ''}
                position="up"
                className="cursor-pointer"
                disabled={condensed}
                close={context === item.type}
              >
                <div
                  className={cn(
                    'relative z-10 flex h-7 w-7 items-center justify-center rounded-full transition-colors',
                    isActive
                      ? 'text-primary-500'
                      : 'text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:text-gray-600 dark:hover:bg-black/50 dark:hover:text-gray-400',
                  )}
                >
                  <Icon name={item.icon} size={12} />
                </div>
              </Tooltip>

              {isActive && (
                <MotionLayout>
                  <m.div
                    layoutId={`${condensed ? 'nav' : 'chat'}-toolbar-focus`}
                    transition={{ type: 'spring', stiffness: 500, damping: 40, mass: 0.5 }}
                    className="absolute top-0 z-0 h-7 w-7 rounded-full bg-white outline outline-1 outline-black/10 dark:bg-black dark:outline-white/10"
                  />
                </MotionLayout>
              )}
            </li>
          )
        })}
      </ul>
    </LayoutGroup>
  )
}
